export default __webpack_public_path__ + "static/media/house_one.7960b566.jpg";